import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import MainView from './views/MainView.vue';

@Component({
    components: {
        MainView
    }
})
export default class SentStatus extends Vue {}
